import { HotelCitiesMainContentPropertiesType } from "@website/accommodation-ui/hotel-cities-main-content/hotel-cities-main-content.types";
import uniqBy from "lodash-es/uniqBy";
import { useRouter } from "next/router";
import { useCallback, useMemo, useState } from "react";

export const useHotelCitiesMainContent = (
  properties: HotelCitiesMainContentPropertiesType
) => {
  const {
    hotelList,
    loading,
    hasError,
    hotelsSuggested,
    hasFilters,
    hasLoadMoreButton,
    clearAllFilters,
    setIsSearchPanelOpen
  } = properties;
  const router = useRouter();

  const [limit, setLimit] = useState(20);
  const hotelListChunk = useMemo(
    () => hotelList?.slice(0, limit),
    [hotelList, limit]
  );
  const remainHotels = useMemo(
    () => hotelList?.length - hotelListChunk?.length,
    [hotelList?.length, hotelListChunk?.length]
  );

  const handleNotFoundAction = useCallback(() => {
    if (hasFilters) {
      clearAllFilters?.();
    } else {
      setIsSearchPanelOpen(true);
    }
  }, [hasFilters, clearAllFilters, setIsSearchPanelOpen]);

  const suggestionOrder = useMemo(
    () => Math.min(Math.max(hotelList?.length - 1, 1), 3),
    [hotelList]
  );

  const onLoadMore = useCallback(() => {
    setLimit((previousState) => previousState + 20);
  }, []);

  return {
    suggestionOrder,
    hotelList: hasLoadMoreButton
      ? uniqBy(hotelListChunk, "id")
      : uniqBy(hotelList, "id"),
    loading,
    hasNoResults: !loading && hotelList?.length === 0,
    hasError,
    hasSort:
      router.query?.["order_by"] && router.query?.["order_by"] !== "selling",
    hasFilters,
    hasHotelSuggestion: hotelsSuggested?.length !== 0,
    handleNotFoundAction,
    hasLoadMoreButton,
    remainHotels,
    onLoadMore
  };
};
